<template>
	<b-modal :ref="modalRefName" size="xl" hide-footer style="z-index: 50">
		<template #modal-title>
			<span style="color: #1a3e53">
				<b-icon icon="file-check" />
				{{ $t("Enregistrement de votre {documentType}", { documentType: page.type === "invoices" ? $t("facture") : $t("devis") }) }}
			</span>
		</template>

		<b-row v-if="loadedDocument" style="z-index: 60">
			<b-col cols="8" class="preview-wrapper">
				<div class="preview-loader">
					<b-icon icon="stopwatch" font-scale="3" animation="cylon" />
					<p id="cancel-label">
						{{ $t("Chargement de votre aperçu...") }}
					</p>
				</div>
				<b-img-lazy id="preview" style="position: relative; z-index: 999" fluid :src="previewUrl" />
			</b-col>

			<!-- Actions -->
			<b-col cols="4">
				<b-row v-if="loadedDocument.status === 'draft' && showActions === false">
					<b-col cols="12" class="saveInformation left-center">
						<u> <b>{{ $t("Enregistrer en brouillon") }}</b> </u>
						<p v-if="page.type === 'invoices'">
							{{ $t("La facture reste modifiable le temps qu’elle est au format brouillon. Elle ne dispose pas d’un numéro et se nomme Pro forma.") }}
						</p>

						<p v-else>
							{{ $t("Le devis reste modifiable le temps qu’il est au format brouillon.") }} <br>
							{{ $t("Il ne dispose pas d’un numéro et se nomme Pro forma.") }}
						</p>

						<p>
							{{ $t("Pour ventiler sur plusieurs comptes comptables pensez à vérifier les affectations comptables (comptes de produits) de vos lignes de facturation à l’aide de à gauche de chaque ligne.") }}
						
							(<svg
								xmlns:svg="http://www.w3.org/2000/svg"
								xmlns="http://www.w3.org/2000/svg"
								version="1.1"
								class="bi"
								fill="#0056b3"
								alt="icon"
								role="img"
								focusable="false"
								height="1.5em"
								width="1.5em"
								viewBox="-2 -8  32 20"
							>
							<g transform="translate(-2, -8)">
								<path
									id="path30"
									clip-rule="evenodd"
									d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10zM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8z"
									fill-rule="evenodd"
								/>
							</g>
							<g transform="translate(15, -8)">
								<path
									id="path30-5"
									fill-rule="evenodd"
									d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
									clip-rule="evenodd"
								/>
							</g>
						</svg>)

						 	{{ $t("Cette ventilation par ligne ne sera plus disponible quand vous enregistrerez au format définitif.") }}
						</p>


						<b-overlay
							:show="savingDocument"
							rounded
							opacity="0.6"
							spinner-small
							spinner-variant="primary"
							class="d-inline-block"
							style="width: 100%"
						>
							<s-button type="border" class="w-100" :disabled="savingDocument" @click="saveDraft">
								{{ $t("Enregistrer en brouillon") }}
							</s-button>
						</b-overlay>
					</b-col>

					<!-- Confirmer et comptabiliser -->
					<b-col cols="12" class="saveInformation left-center" style="margin-top: 10px">
						<u> <b>{{ $t("Confirmer et comptabiliser") }}</b> </u>
						<p v-if="page.type === 'invoices'">
							{{ $t("Une fois confirmée, la facture obtient un numéro unique, n’est plus modifiable et est comptabilisée. Toute erreur devra être corrigée par un avoir.") }}
						</p>

						<p v-else>
							{{ $t("Une fois confirmé, le devis obtient un numéro unique et n’est plus supprimable mais reste modifiable.") }}
						</p>

						<b-overlay
							:show="savingDocument"
							rounded
							opacity="0.6"
							spinner-small
							spinner-variant="primary"
							class="d-inline-block"
							style="width: 100%"
						>
							<s-button
								id="confirmer"
								class="w-100"
								type="success"
								:disabled="savingDocument || !isConfirmationBtnEnabled"
								@click="finalizeDocument"
							>
								{{ page.type === "invoices" ? $t("Confirmer et comptabiliser") : $t("Confirmer") }}
							</s-button>
							<div
								v-if="!isConfirmationBtnEnabled"
								class="mutted"
								style="margin-top: 10px;"
							>
								{{ $t("Vous ne pouvez confirmer cette facture car sa date d’écriture est supérieure à aujourd’hui mais vous pouvez l’enregistrer en brouillon puis programmer la confirmation automatique à cette date.") }}
							</div>
						</b-overlay>
					</b-col>
				</b-row>

				<b-row v-else>
					<b-col cols="12" class="left-center">
						<div v-if="loadedDocument.status !== 'draft'" class="btn-accounting mb-2">
							<p class="btn-accounting-text"> {{ $t("Comptabilisé") }} </p>
						</div>
						<s-button class="mb-2 w-100" style="margin-bottom: 12px !important" type="border" @click="download">
							{{ pageType === "facture" ? $t("Télécharger ma facture") : $t("Télécharger mon devis") }}
						</s-button>
						<s-button class="mb-2 w-100" style="margin-bottom: 12px !important" type="border" @click="print">
							{{ pageType === "facture" ? $t("Imprimer ma facture") : $t("Imprimer mon devis") }}
						</s-button>
						<s-button class="mb-2 w-100" style="margin-bottom: 12px !important" type="border" @click="send">
							{{ $t("Envoyer par email") }}
						</s-button>
						<s-button class="mb-4 w-100" style="margin-bottom: 12px !important" type="border" @click="redirectToWriting">
							{{ pageType === "facture" ? $t("Écrire une nouvelle facture") : $t("Écrire un nouveau devis") }}
						</s-button>
						<s-button class="w-100" type="success" @click="redirectToListing">
							{{ pageType === "facture" ? $t("Retourner à la liste des factures") : $t("Retourner à la liste des devis") }}
						</s-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
	import { mapState } from "vuex";
	import { query, getToken } from "sinao-corejs";
	import print from "print-js";
	import i18n from "@/i18n";

	export default {
		props: {
			status: {
				type: Boolean,
				required: true,
				default: false
			}
		},
		data() {
			return {
				modalRefName: "ModalBillingSave",
				previewUrl: null,
				savingDocument: false,
				showActions: false,
				isConfirmationBtnEnabled: true,
				authParam: "",
			};
		},
		computed: {
			...mapState({
				app: state => state.app,
				page: state => state.page,
				loadedDocument: state => state.home.loadedDocument,
				contactInfos: state => state.contacts.contactInfos,
				third_account: state => state.contacts.thirdAccount,
				removePreview: state => state.home.removePreview
			}),
			pageType() {
				if (this.page.type === "invoices") {
					return "facture";
				}

				return "devis";
			},
      urlQueryParams() { // return an Object with pairs {key: value}
        const query = window.location.search.substring(1); // Remove the "?" at the start
        const pairs = query.split("&");
        const params = {};

        for (let i = 0; i < pairs.length; i++) {
          const [key, value] = pairs[i].split("=");
          if (key) {
            params[decodeURIComponent(key)] = decodeURIComponent(value || "");
          }
        }

        return params;
      },
			document_written_at_is_not_futur() {
				const Now = new Date();
				const Document_written_at = new Date(this.loadedDocument.written_at);
				return Now.getTime() >= Document_written_at.getTime();
			}
		},
		watch: {
			status() {
				this.showActions = false;

				if (this.status) {
					this.$refs[this.modalRefName].show();
				} else {
					this.$refs[this.modalRefName].hide();
				}
			},
			async loadedDocument() {
				try {
					this.previewUrl = this.getPreviewUrl();
					//await this.getPreview();
				} catch (error) {
					console.error(error);
				} finally {
					// we must prevent finalize an invoice written_at in futur date
					if (this.pageType !== "facture")
						this.isConfirmationBtnEnabled = true;
					else
						this.isConfirmationBtnEnabled = this.document_written_at_is_not_futur;
				}
			}
		},
		destroyed() {
			this.showActions = false;
			this.previewUrl = null;
			this.$emit("update:status", false);
		},
		mounted() {
			const _token = getToken() ?? this.app.token;
			const _api_key = this.getApiKey() ?? this.app.apiKey;
			this.authParam = _token ? `token=${_token}` : `api_key=${_api_key}`;
			
			this.$refs[this.modalRefName].$on("shown", () => {
				// Remove onbeforeunload
				window.onbeforeunload = null;
			});

			this.$refs[this.modalRefName].$on("hidden", () => {
				if (this.savingDocument === false && process.env.NODE_ENV === "production") {
					// Setup onbeforeunload
					window.onbeforeunload = function() {
						return i18n.t("Êtes-vous sûrs de vouloir fermer la page ?");
					};
				}

				this.$emit("update:status", false);
			});
		},
		methods: {
      getPreviewUrl() {
        return `${this.app.apiUrl}/apps/${this.app.id}/${this.page.type}/${
            this.loadedDocument.id
        }/preview.jpg?${this.authParam}&timestamp=${new Date().getTime()}`;
      },
			async getPreview() {
				try {
					return query({
						operationId: "app.documents.sales.invoices.preview",
						params: {
							appId: this.app.id,
							id: this.loadedDocument.id,
							// base64: 1,
							timestamp: new Date().getTime()
						}
					});
				} catch (error) {
					console.error(error);
				}
			},
			saveDraft() {
				if (this.removePreview == true) {
					this.$refs[this.modalRefName].hide();
				} else {
					this.showActions = true;
				}
			},
			async finalizeDocument() {
				try {
					if (!this.contactInfos?.id) {
						return this.$bvToast.toast(i18n.t("Veuillez ajouter un client pour pouvoir confirmer ce document."), {
							title: i18n.t("Erreur d’enregistrement"),
							variant: "danger",
							solid: true
						});
					}

					this.savingDocument = true;

					const { id } = this.loadedDocument;

					if (id) {
            try {
              const response = await query({
                operationId: `app.documents.sales.${this.page.type}.finalize`,
                params: {
                  appId: this.app.id,
                  id
                }
              });
              this.$bvToast.toast(i18n.t(this.page.type === "invoices" ? "Facture numéro" : "Devis numéro", {number: response.number}),
                {
                  title: i18n.t(this.page.type === "invoices" ? "Facture confirmée" : "Devis confirmé"),
                  variant: "success",
                  solid: true
                });
              if (this.removePreview === true) {
                this.$refs[this.modalRefName].hide();
              } else {
                setTimeout(() => {
                  // reload the preview
                  this.previewUrl = this.getPreviewUrl();
                }, 10000)
                this.showActions = true;
              }
            } catch (e) {
              const reg = new RegExp('sales_' + this.page.type + '.sales_' + this.page.type +'_number_unique', 'i')
              // Handle specific error for 422 status
              if (reg.test(e.response?.data?.message ?? e.message)) {
                this.$bvToast.toast(i18n.t("Invoice_confirmation_error_number_exists"),
                {
                  title: i18n.t("Confirmation impossible"),
                  variant: "danger",
                  solid: true
                });
              } else {
                this.$bvToast.toast(i18n.t("Document_confirmation_error") + " (" + (e.response?.data?.message ?? e.message ?? '') + ")",
                {
                  title: i18n.t("Erreur d’enregistrement"),
                  variant: "danger",
                  solid: true
                });
              }
            }
					}
				} catch (error) {
					this.showActions = false;

					const status = error?.response?.status;

					if (status) {
						switch (status) {
							case 403:
								this.$bvToast.toast(i18n.t("Vous ne pouvez pas finaliser un document validé."),
								{
									title: i18n.t("Erreur d’enregistrement"),
									variant: "danger",
									solid: true
								});
								break;

							case 422:
								this.$bvToast.toast(
									i18n.t("La somme des avoirs sur la facture ne peut excéder le montant total de la facture."),
									{
										title: i18n.t("Erreur d’enregistrement"),
										variant: "danger",
										solid: true
									}
								);
								break;

							default:
								this.$bvToast.toast(
									i18n.t("Nous avons rencontré une erreur, réessayez dans quelques minutes ou contactez-nous via la bulle de tchat en bas à droite."),
									{
										title: i18n.t("Erreur d’enregistrement"),
										variant: "danger",
										solid: true
									}
								);
								break;
						}
					}
				} finally {
					this.savingDocument = false;
				}
			},
			download() {
				const { apiUrl, documentId, id } = this.app;
				const a = document.createElement("a");

				const url = `${apiUrl}/apps/${id}/${
					this.page.type
				}/${documentId}/pdf?${this.authParam}&ts=${Math.floor(Math.random() * 100)}`;

				a.href = url;
				a.setAttribute("download", `${documentId}.pdf`);
				a.click();
			},
			send() {
				const { documentId } = this.app;

				this.dispatchEvent({
					modalName: null,
					source: "billing",
					action: "send_document",
					data: {
						id: documentId,
						type: this.page.type === "invoices" ? "invoice" : "quote"
					}
				});
			},
			print() {
				const { apiUrl, documentId, id } = this.app;

				const url = `${apiUrl}/apps/${id}/${
					this.page.type
				}/${documentId}/pdf?${this.authParam}&ts=${Math.floor(Math.random() * 100)}`;

				print(url);
			},
			redirectToListing() {
				this.$store.dispatch("redirectToListing");
			},
			redirectToWriting() {
				this.$store.dispatch("redirectToWriting");
			},
      getApiKey() {
       return this.urlQueryParams['api_key'] ?? null;
      }
    }
	};
</script>

<style lang="scss">
	.preview-wrapper {
		position: relative;
		min-height: 320px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.preview-loader {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		z-index: 10;
	}

	.btn-accounting {
		background: #c3e0c266;
		border: 1px solid #c4c4c4;
		box-sizing: border-box;
		border-radius: 10px;
		height: 43px;
		padding: 12px;

		&-text {
			text-align: center;
			font-weight: 500;
			font-size: 13px;
			line-height: 19px;
			text-align: center;
			letter-spacing: 0.01em;
			color: #369e3b;
		}
	}
	.mutted {
		color: #aaa;
		font-style: italic;
	}

	// @media screen and (max-width: 768px) {
	@media screen and (min-width: 800px) and (max-width: 935px) {
		.saveInformation {
			max-width: 50% !important;
			flex: 0 0 50% !important;
			margin-top: 10px !important;
		}
	}

	@media screen and (max-width: 935px) {
		.modal {
			top: 48px !important;
		}

		.modal-title {
			font-size: 16px !important;
		}

		.modal-body > .row {
			flex-direction: column-reverse !important;
		}

		.col-8, .col-4 {
			max-width: 100% !important;
			flex: 0 0 100% !important;
		}

		.col-4 {
			margin-bottom: 12px;
		}

		.saveInformation {
			p, u {
				display: none !important;
			}
		}
	}
</style>
